/**
Invited - the user to whom the invitation has been sent, but he hasn't opened the link

Signed-up - the user who opened the invitation, authorised, accepted the invite but hasn't passed onboarding

inducted - the user who passed onboarding, but hasn't used the AI assistant

Engaged - the user who has used AI assistant at least once
 */
export enum SpaceMemberTag {
  Invited = 'invited',
  SignedUp = 'signed-up',
  Inducted = 'inducted',
  Engaged = 'engaged',
}
